module.exports = __webpack_public_path__ + "img/gross-margin-1@2x.6757f98b.png";